export default __webpack_public_path__ + "static/media/xitongguanli1_w.57787fc4.png";